export const OUTBOUND_DEALS_COLUMNS = [
  { name: 'id',                      label: 'ID' },
  { name: 'payments.created_at',     label: 'Created At' },
  { name: 'payments.paid_at',        label: 'Paid At' },
  { name: 'deals.pickup_at',         label: 'Pickup At' },
  { name: 'deals.reference_number',  label: 'Order Number' },
  { name: 'users.email',             label: 'User Email' },
  { name: 'user_details.name',       label: 'Customer Name' },
  { name: 'user_details.phone',      label: 'Phone Number' },

  {
    name: 'products.sku_list',
    label: 'SKU(s) List / Items inside Deal',
    thStyle: { minWidth: 280, width: 320 }, // tweak to taste
    tdStyle: { minWidth: 280, width: 320, whiteSpace: 'pre-line' }
  },

  { name: 'deals.final_payment',     label: 'Final Payment' },
  { name: 'deals.down_payment',      label: 'Down Payment' },
  { name: 'deals.state',             label: 'State' },
  { name: 'deals.note',              label: 'Catatan' },
]
